import React, { useEffect, useState } from "react";
import { MarqueeSelection } from "@fluentui/react/lib/MarqueeSelection";
import { DetailsList, DetailsListLayoutMode, IColumn, Selection, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { ProviderConsumer as FluentUIThemeConsumer } from '@fluentui/react-northstar';
import { ThemeColorScheme } from "../shared/common/TeamsTheme";
import { EnumSortOrderType } from "../tikit/toolbar/CustomViewContextProvider";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SETTINGS_PAGES, TREE_LISTING_CONSTANTS } from "../shared/utils/constants";
import { NameUserAvatar } from "./NameUserAvatar";
import { UserListMenu } from "./UserListMenu";
import Style from './UserForm.module.css';


const _onColumnClick = (onColumnClickCallback: (column: IColumn) => void) => (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
  onColumnClickCallback(column);
};

const UserDetailList = (props) => {
  const [selection, setSelection] = useState<Selection | undefined>();
  const [columns, setColumns] = useState([] as IColumn[]);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    const _selection: Selection = new Selection({ onSelectionChanged: () => { } });
    setSelection(_selection);

    setColumns(userColumns());
  }, [props.rows, props.isExternalUsersEnabled])

  const renderRecord = (key: string) => (item) => {
    if (key == 'FullName')
      return <div onClick={() => history.push((location.pathname.indexOf('/settings/') != -1) ? `/settings/${SETTINGS_PAGES.USERS}/${item.Id}` : `/${SETTINGS_PAGES.USERS}/${item.Id}`)} className="cursor-pointer" style={{ color: "var(--mgt-theme-brand-foreground)" }}>
        <NameUserAvatar user={item} />
        {item.IsArchived && (<span className={Style.IsArchivedName}>
          {TREE_LISTING_CONSTANTS.archived}
        </span>)}
        </div>
    else if (key == 'IsExternalUser')
      return <span>{item[key] ? t('common.buttons.yes') : t('common.buttons.no')}</span>;
    else if (key == 'options')
      return <UserListMenu id={item.Id} isUserLicensed={props.isUserLicensed} name={item.FullName} isArchived={item.IsArchived} reloadPage={props.reloadPage} />;
    
    return <span>{item[key]}</span>;
  };

  const userColumnExtras = (key: string, isResizable: boolean, isCollapsible: boolean) => {
    return { key: key, onColumnClick: _onColumnClick(props.onColumnClick),
      isSorted: props.sortOrder.orderBy === key ? true : null, isSortedDescending: props.sortOrder.orderBy === key && props.sortOrder.orderType === EnumSortOrderType.desc,
      isResizable: isResizable, isCollapsible: isCollapsible
    }
  }
  const userColumns = (): IColumn[] => {
    return [
      {
        name: t('users.user-form.name'), minWidth: 250, maxWidth: 300, isMultiline: false, onRender: renderRecord('FullName'),
        ...userColumnExtras('FullName', true, false)
      },
      {
        name: t('users.user-form.email-address'), minWidth: 300, isMultiline: false, onRender: renderRecord('Email'),
        ...userColumnExtras('Email', true, false)
      },
      ...(props.isExternalUsersEnabled ? [
        {
          name: t('users.user-form.is-external-user'), minWidth: 148, maxWidth: 150, isMultiline: false, onRender: renderRecord('IsExternalUser'),
          ...userColumnExtras('IsExternalUser', true, true)
        },
        {
          name: t('users.user-form.source'), minWidth: 147, maxWidth: 150, isMultiline: false, onRender: renderRecord('Source'),
          ...userColumnExtras('Source', true, true)
        }
      ] : []),
      {
        name: t('users.user-form.department'), minWidth: 150, maxWidth: 150, isMultiline: false, onRender: renderRecord('Department'),
        ...userColumnExtras('Department', true, true)
      },
      {
        name: t('users.user-form.job-title'), minWidth: 149, maxWidth: 150, isMultiline: false, onRender: renderRecord('JobTitle'),
        ...userColumnExtras('JobTitle', true, false)
      },
      {
        name: t('users.user-form.office-phone'), minWidth: 125, maxWidth: 125, isMultiline: false, onRender: renderRecord('OfficePhone'),
        ...userColumnExtras('OfficePhone', true, true)
      },
      {
        name: t('users.user-form.mobile-phone'), minWidth: 125, maxWidth: 125, isMultiline: false, onRender: renderRecord('MobilePhone'),
        ...userColumnExtras('MobilePhone', true, true)
      },
      {
        name: t('users.tabs.licenses'), minWidth: 150, maxWidth: 150, isMultiline: true, onRender: renderRecord('productNames'),
        ...userColumnExtras('productNames', true, false)
      },
      {
        name: ' ', minWidth: 50, maxWidth: 50, isMultiline: true, onRender: renderRecord('options'),
        ...userColumnExtras('options', true, false), isMenuOpen: true
      },
    ]
  }

  return selection ? (<FluentUIThemeConsumer render={(globalTheme) => (
    <div className={`py-3.5 pl-2.5 min-h-32`} style={{ backgroundColor: 'var(--mgt-theme-background2)', ...ThemeColorScheme(globalTheme.siteVariables) }}>
      <MarqueeSelection selection={selection}>
        <DetailsList items={props.rows} compact={false} columns={columns} selectionMode={SelectionMode.none} setKey='multiple' layoutMode={DetailsListLayoutMode.justified} isHeaderVisible={true} selection={selection}
          selectionPreservedOnEmptyClick={true} enterModalSelectionOnTouch={true} ariaLabelForSelectionColumn='Toggle selection' ariaLabelForSelectAllCheckbox='Toggle selection for all items' checkButtonAriaLabel='select row' />
      </MarqueeSelection>
    </div>
  )} />) : (<></>);
}

export default UserDetailList;